/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Misa_DraftInputs */

const vi_einvoice_stuck_misa_draft = /** @type {(inputs: Einvoice_Stuck_Misa_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA đang giữ một nháp chưa phát hành.`)
};

/**

* @param {Einvoice_Stuck_Misa_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_misa_draft = /** @type {((inputs?: Einvoice_Stuck_Misa_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Misa_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_misa_draft(inputs)
});